export default __webpack_public_path__ + "static/media/img_4.91e9296b.JPG";